import React, { Component } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { Grid, Hidden, } from "@material-ui/core";
import Slider from "react-slick";
import "../../../styles/home.scss";
import Pagination from "@material-ui/lab/Pagination";
import { POST, GET } from "api";
import moment from "moment";
import Swal from "sweetalert2";
import ReactPixel from "react-facebook-pixel";
import { Helmet } from "react-helmet";
import { params } from 'utils'
import YoutubeEmbed from "../../../components/youtube/YoutubeEmbed";
const settings = {
     dots: true,
     infinite: false,
     speed: 500,
     slidesToShow: 4,
     slidesToScroll: 4,
     initialSlide: 0,
     responsive: [
          {
               breakpoint: 1080,
               settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true,
               },
          },
          {
               breakpoint: 580,
               settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
               },
          },
     ],
};

export default class Home extends Component {
     constructor(props) {
          super(props);
          this.state = {
               newpage: [],
               promotion: [],
               page: 1,
          };
     }
     componentDidMount() {
          this.getPromotion();

          ReactPixel.init("yourPixelIdGoesHere");
          ReactPixel.pageView();
     }
     getPromotion = async () => {
          try {
               let result = await GET("/promotion/user");
               // console.log('result', result);
               this.setState({ promotion: result, newpage: result });
               this.onChangePage("t", 1);
          } catch (error) {
               console.log("getcopytrade error", error);
          }
     };
     moredetail = (promotion_id) => {
          // let copy_trade_list=this.state;
          this.props.history.push(`/community_detail/${promotion_id}` + params);
     };
     onChangePage = (e, value) => {
          this.setState({ page: value });
     };
     login() {
          window.location.href = "/login" + window.location.search;
     }
     register() {
          window.location.href = "/register" + window.location.search;
     }
     copytrade() {
          window.location.href = "/social-trade" + window.location.search;
     }
     ea() {
          window.location.href = "/ea" + window.location.search;
     }
     cashback() {
          window.location.href = "/cash-back" + window.location.search;
     }
     ib() {
          window.location.href = "/broker" + window.location.search;
     }
     ea_dashboard(){
          window.location.href = "/ea_dashboard" + window.location.search;
     }
     course(){
          window.location.href = "/course" + window.location.search;
     }
     render() {
          let { page, promotion } = this.state;
          let pages = page - 1;
          let detailpage = promotion.slice(pages * 3, page * 4);
          let count = Math.ceil(promotion.length > 0 && promotion.length / 3);
          return (
               <React.Fragment>

                    <div className="home-1">
                         <Row>
                              <Col className="left" xs={12} sm={8}>
                                   <p className="title">
                                        <strong className="text-white">Fx society </strong>
                                        เราเป็นตัวกลางที่รวบรวมบริการต่างๆ จากเหล่าผู้พัฒนา Products ชั้นนำทั่วโลก
                                        เพื่อให้การทำกำไรแล้วลงทุนในตลาดเงินง่ายขึ้น
                                   </p>
                                   <p className="detail">
                                        รวมถึงคอร์สสอนเทรดออนไลน์ ให้คุณกลายเป็น Trader มืออาชีพได้ โดยเริ่มต้นจาก 0
                                        หรือ เทคนิคการทำกำไร บริการเครื่องมือช่วยเทรดต่างๆ และคืน Cash back
                                        คอมมิสชั่นทีเสียให้โบรกเกอร์
                                   </p>
                                   <div className="login">
                                        <button
                                             className="btn btn-border-orange bigger radius mw-200"
                                             onClick={this.login}
                                        >
                                             Login
                                        </button>
                                        <button
                                             className="btn btn-orange bigger radius mw-200 ml-4"
                                             onClick={this.register}
                                        >
                                             Register
                                        </button>
                                   </div>
                              </Col>
                              <Col className="right" xs={0} sm={4}>
                                   <img src={require("./images/handmobile.png")} alt="" />
                              </Col>
                         </Row>
                         <a href="#home2" className="mouse_scroll">
                              <img src={require("./images/mousescroll.png")} alt="" />
                         </a>
                    </div>
                    <div id="home2" className="home-2">
                         <div className="title">
                              <strong className="text-orange">ขั้นตอนการสมัคร</strong>
                         </div>
                         <Row>
                              <Col className="left" xs={12} sm={8}>
                                   <Row>
                                        <Col xs={12} lg={12} xl={6}>
                                             <p>
                                                  1. กดปุ่ม Register
                                                  <br />
                                                  สมัครเป็นสมาชิกกับเรา <strong className="text-orange">ฟรี!</strong>
                                                  <br />
                                                  เพื่อใช้บริการต่างๆใน Platform
                                             </p>
                                             <p>
                                                  2. เปิดพอร์ตกับโบรกเกอร์พันธมิตรของเรา
                                                  <br /> ยืนยันตัวตนตามขั้นตอนให้เสร็จสิ้น
                                             </p>
                                        </Col>
                                        <Col xs={12} lg={12} xl={6}>
                                             <p>
                                                  3. เลือกใช้สินค้าและบริการของเรา EA,
                                                  <br />
                                                  DashBoard, Signals, Copytrade, คอร์สเรียน
                                                  <br />
                                                  และรับสิทธ์ <strong className="text-orange">Cash Back </strong>
                                                  <br />
                                                  จากทุกบริการได้ทันที
                                             </p>
                                             <div className="register d-flex justify-content-between p-3 border-gray h3">
                                                  <strong className="text-orange">สมัครทันที!</strong>
                                                  <button
                                                       className="btn btn-orange radius mw-150"
                                                       onClick={this.register}
                                                  >
                                                       Register
                                                  </button>
                                             </div>
                                        </Col>
                                   </Row>
                              </Col>
                              <Col className="right" xs={0} sm={4}>
                                   <img src={require("./images/phone.png")} alt="" />
                              </Col>
                         </Row>
                         {/* <YoutubeEmbed embedId="kdU6TTnIE0g" /> */}
                         {/* <div className="video">
                                   <iframe
                                        // width="100%"
                                        src={"https://www.youtube.com/embed/kdU6TTnIE0g"}
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        // height="100%"
                                        width="853"
                                        height="480"
                                   />
                              </div> */}
                         <Hidden smDown>
                              <div className="video">
                                   <iframe
                                        width="100%"
                                        src={"https://www.youtube.com/embed/kdU6TTnIE0g"}
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        height="100%"
                                   />
                              </div>
                         </Hidden>
                         <Hidden mdUp>
                              <div className="video">
                                   <iframe
                                        width="100%"
                                        src={"https://www.youtube.com/embed/kdU6TTnIE0g"}
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        height="75%"
                                   />
                              </div>
                         </Hidden>
                         
                         
                    </div>

                    <div id="home3" className="home-3">
                         <div className="title">
                              <img src={require("./images/ourservice.png")} alt="" />
                              <span>Our Service</span>
                         </div>

                         <Row className="mt-5">
                              <Col xl={4} className="mt-3">
                                   <div className="pic">
                                        {" "}
                                        <img src={require("../../../images/team.jpg")} alt="team" />
                                   </div>
                                   <div className="icon">
                                        <img src={require("../social-trade/images/icon-01.png")} alt="" />
                                   </div>
                                   <div className="item-ourservice">
                                        <div className="main">
                                             <h3 className="text-center">Copy Trade </h3>
                                             <h3 className="text-center"> เทรดทำกำไรตาม Master</h3>
                                        </div>
                                        <div className="detail text-center">
                                             เราได้วิเคราะห์และรวบรวม Copy Trade ที่มีผลงานยอดเยี่ยมมาไว้ที่นี่
                                             โดยสามารถเทรดตาม Master ผู้มีประสบการณ์ได้ง่ายๆ เพียงคลิกเดียวเท่านั้น
                                             และยังได้รับ Cash back จากค่า lot เทรด คืนอีกด้วย
                                        </div>

                                        <div className="button">
                                             <button className="btn btn-orange radius mw-150" onClick={this.copytrade}>
                                                  ดูข้อมูลเพิ่มเติม
                                             </button>
                                        </div>
                                   </div>
                              </Col>
                              <Col xl={4} className="mt-3">
                                   <div className="pic">
                                        {" "}
                                        <img src={require("../../../images/ai.jpg")} alt="team" />
                                   </div>
                                   <div className="icon">
                                        <img src={require("../ea/images/icon-03.png")} alt="" />
                                   </div>
                                   <div className="item-ourservice">
                                        <div className="main ">
                                             <h3 className="text-center">EA Robot เทรดอัตโนมัติ</h3>
                                        </div>

                                        <div className="detail text-center">
                                             รวม EA จากผู้พัฒนาชั้นนำ ทั่วโลก มาไว้ที่นี้ พร้อมมีบริการ ติดตั้ง EA
                                             พร้อมเซิฟเวอร์ รันให้ฟรี! เริ่มต้นทำกำไรได้ง่ายๆ ด้วยระบบ Robot เทรด ให้ 24
                                             ช.ม พร้อมรับ Cashback คืนจากทุกการเทรดของ EA อีกด้วย
                                        </div>

                                        <div className="button">
                                             <button className="btn btn-orange radius mw-150" onClick={this.ea}>
                                                  ดูข้อมูลเพิ่มเติม
                                             </button>
                                        </div>
                                   </div>
                              </Col>
                              <Col xl={4} className="mt-3">
                                   <div className="pic">
                                        {" "}
                                        <img src={require("../../../images/cash.jpg")} alt="team" />
                                   </div>
                                   <div className="icon">
                                        <img src={require("../cash-back/images/icon-02.png")} alt="" />
                                   </div>
                                   <div className="item-ourservice">
                                        <div className="main">
                                             <h3 className="text-center">Cash back คืนให้ท่าน </h3>
                                             <h3 className="text-center">สูงสุด 7$ ต่อ Lot</h3>
                                        </div>
                                        <div className="detail text-center">
                                             เพียงท่านเปิดบัญชีเทรดผ่าน Partner ของเรา สามารถใช้ทุกบริการของเราได้ฟรี
                                             แล้วยัง ได้รับ Cashback คืน จากทุกการเทรด ของท่าน ที่เทรดเอง หรือ
                                             เป็นการเทรด ที่มาจากบริการ ของเรา ก็ได้เช่นกัน สามารถ ได้เงินคืน สูงสุดกว่า
                                             7$ / Lot
                                        </div>

                                        <div className="button">
                                             <button className="btn btn-orange radius mw-150" onClick={this.cashback}>
                                                  ดูข้อมูลเพิ่มเติม
                                             </button>
                                        </div>
                                   </div>
                              </Col>
                              <Col xl={4} className="mt-3">
                                   <div className="pic">
                                        {" "}
                                        <img src={require("../../../images/aff.jpg")} alt="team" />
                                   </div>
                                   <div className="icon">
                                        <img src={require("../broker/images/affib2.png")} alt="" />
                                   </div>
                                   <div className="item-ourservice">
                                        <div className="main">
                                             <h3 className="text-center">Affiliate IB</h3>
                                        </div>
                                        <div className="detail text-center">
                                             โอกาสการสร้างรายได้ โดยการเป็นตัวแทน กับ แพลตฟอร์มของเรา รับค่าคอมมิสชั่น
                                             สูงสุดกว่า 14$/Lot จากออเดอร์ การเทรดของ
                                             เพื่อนๆที่ท่านได้แนะนำมาใช้บริการต่างๆกับเรา เพียงสมัครเป็น Affiliate
                                             นำลิ้งผู้แนะนำ ของแพลตฟอร์ม ไปแชร์ได้ทันที
                                        </div>

                                        <div className="button">
                                             <button className="btn btn-orange radius " onClick={this.ib}>
                                                  ดูข้อมูลเพิ่มเติม
                                             </button>
                                        </div>
                                   </div>
                              </Col>
                              <Col xl={4} className="mt-3">
                                   <div className="pic">
                                        {" "}
                                        <img src={require("../../../images/dashboard.png")} alt="team" />
                                   </div>
                                   <div className="icon">
                                        <img src={require("../broker/images/affib2.png")} alt="" />
                                   </div>
                                   <div className="item-ourservice">
                                        <div className="main">
                                             <h3 className="text-center">Dashboard</h3>
                                        </div>
                                        <div className="detail text-center">
                                             เครื่องมือนำเทรดประสิทธิภาพสูง พัฒนามาจากหลากหลายระบบการเทรดที่ยอมรับแล้วว่าทำกำไรได้จริง ฟังก์ชั่นเด่นๆมากมายที่จะทำให้คุณเทรดง่ายและกำไรมากขึ้น
                                        </div>

                                        <div className="button">
                                             <button className="btn btn-orange radius " onClick={this.ea_dashboard}>
                                                  ดูข้อมูลเพิ่มเติม
                                             </button>
                                        </div>
                                   </div>
                              </Col>
                              <Col xl={4} className="mt-3">
                                   <div className="pic">
                                        {" "}
                                        <img src={require("../../../images/course.jpg")} alt="team" />
                                   </div>
                                   <div className="icon">
                                        <img src={require("../broker/images/affib2.png")} alt="" />
                                   </div>
                                   <div className="item-ourservice">
                                        <div className="main">
                                             <h3 className="text-center">Course</h3>
                                        </div>
                                        <div className="detail text-center">
                                             คอร์สเรียน forex สุดพรีเมี่ยม รวมทุกเนื้อหาที่คัดสรรค์มาเพื่อคุณโดยเฉพาะทั้งหมด 31 บทเรียน รวมกว่า 20 ชม.  ที่จะทำให้คุณก้าวสู่การเป็นเทรดเดอร์อย่างเต็มตัว และสามารถทำกำไรได้
                                        </div>

                                        <div className="button" onClick={this.course}>
                                             <button className="btn btn-orange radius ">
                                                  ดูข้อมูลเพิ่มเติม
                                             </button>
                                        </div>
                                   </div>
                              </Col>
                         </Row>
                    </div>
                    <div className="panel _shadow _radius ">
                         <div className="img-resposive -web">
                              <img style={{ display: 'block', marginRight: 'auto', marginLeft: 'auto', width: '70%' }} src={require("../../../images/lifecycle.jpg")} />
                         </div>
                         <div className="img-resposive  -mobile ">
                              <img src={require("../../../images/lifecycle.jpg")} />
                         </div>
                    </div>

                    {/* <div className="panel _shadow _radius ">
                         <div className="d-flex" style={{ justifyContent: "center" }}>
                              <div className="partner-title">Broker Partner</div>
                         </div>
                         <div className="img-resposive2 -web">
                              <img  onClick={() => window.location.assign('/broker' + params)} src={require("../../../images/all_broker.png")} />
                         </div>
                         <div className="img-resposive2  -mobile ">
                              <img onClick={() => window.location.assign('/broker' + params)} src={require("../../../images/all_broker.png")} alt="" />
                         </div>
                    </div> */}
                    {/* <div id="home4" className="home-4">
                    <Row>
                        <Col className="left" xs={12} lg={12} xl={8}>
                            <img src={require('./images/ipad.png')} alt="" />
                        </Col>
                        <Col className="detail" xs={12} lg={0} xl={4}></Col>
                    </Row>
                </div> */}
                    <div className="container">
                         <div id="home6" className="home-6">
                              <div className="d-flex" style={{ justifyContent: "center" }}>
                                   <div className="promotion-title">Community</div>
                              </div>

                              <Row xs={8}>
                                   {detailpage?.map((e, i) => (
                                        <Col xs={12} md={4} xl={3}>
                                             <div
                                                  className="panel _shadow _radius more-detail h-100"
                                                  onClick={() => this.moredetail(e.promotion_id)}
                                             >
                                                  <div>
                                                       {" "}
                                                       <img
                                                            src={require("../../../images/flag.png")}
                                                            alt="flag"
                                                            style={{ height: "80px", marginTop: "-25px" }}
                                                       />
                                                  </div>
                                                  {/* <div className="promotion-title-each"> {e?.title}</div>  */}
                                                  <div>
                                                       <img
                                                            src={e?.image}
                                                            style={{ height: "200px" }}
                                                            alt="promotion1"
                                                       />

                                                       <div className="text-blue" style={{ fontSize: "16px" }}>
                                                            {e?.title}
                                                       </div>
                                                  </div>

                                                  <p className="text-gray" style={{ fontSize: "14px" }}>
                                                       เขียนเมื่อ : {moment(promotion.create_at).format("LLLL")}
                                                  </p>
                                                  {/* <text>
                     ทดสอบบบบ1
             </text> */}
                                             </div>
                                        </Col>
                                   ))}
                              </Row>

                              {/* <Pagination

     page={this.state.page}
     count={count}
     className="pagination-responsive"
     onChange={this.onChangePage}
 ></Pagination> */}
                         </div>
                    </div>
               </React.Fragment>
          );
     }
}
